import React from 'react';

const NotificationAlertPage = ({ pageTitle }) => {
    return <></>;
};

export default NotificationAlertPage;
